module.exports = __webpack_public_path__ + "img/site-0-4.f39efdbe.svg";